import { Filters } from '~/modules/management/pages/Attendances';
import api from '~/shared/services/api';

export default async function getAttendanceFilters(
  client_company_id?: number | null,
  demand_id?: number | null,
  only_allowed_employee?: boolean,
): Promise<Filters> {
  if (!only_allowed_employee) only_allowed_employee = false;

  const { data } = await api.get<Filters>('attendances/filters', {
    params: {
      client_company_id,
      demand_id,
      only_allowed_employee: only_allowed_employee ? 1 : 0,
    },
  });

  return {
    companies: data.companies.map((comp) => {
      return {
        ...comp,
        label: comp.name,
        value: comp.company_id,
      };
    }),
    demands: data.demands.map((dem) => {
      return {
        ...dem,
        label: dem.name,
        value: dem.id,
      };
    }),
    attendances_company: data?.attendances_company?.map((attComp) => {
      return {
        ...attComp,
        label: attComp.name,
        value: attComp.id,
      };
    }),
    attendances_demand: data?.attendances_demand?.map((attDem) => {
      return {
        ...attDem,
        label: attDem.name,
        value: attDem.id,
      };
    }),
  };
}
